export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9435.e75cc246.jpg";